module.exports = __webpack_public_path__ + "img/gorra_2.bc19c929.png";